
            var preact = window.preact;
            var hooks = window.preactHooks;
            module.exports = {
              createElement: preact.h,
              Fragment: preact.Fragment,
              Component: preact.Component,
              createContext: preact.createContext,
              createRef: preact.createRef,
              useState: hooks.useState,
              useEffect: hooks.useEffect,
              useRef: hooks.useRef,
              useCallback: hooks.useCallback,
              useMemo: hooks.useMemo,
              useContext: hooks.useContext,
              useReducer: hooks.useReducer,
              render: preact.render,
              hydrate: preact.hydrate,
            };
          